import { Navigate, Route, Routes } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";

import { LeverIntegrationEditPage } from "./lever/LeverIntegrationEditPage";
import { PageUpIntegrationEditPage } from "./pageup/PageUpIntegrationEditPage";
import { SuccessFactorsIntegrationEditPage } from "./successfactors/SuccessFactorsIntegrationEditPage";
import { WorkdayIntegrationEditPage } from "./workday/WorkdayIntegrationEditPage";
import { GreenhouseIntegrationEditPage } from "./greenhouse/GreenhouseIntegrationEditPage";
import { IcimsIntegrationEditPage } from "./icims/IcimsIntegrationEditPage";
import { UnifiedIntegrationEditPage } from "./unified/UnifiedIntegrationEditPage";
import { WorkableIntegrationEditPage } from "./workable/WorkableIntegrationEditPage";

export function AtsIntegrationEditRoutes() {
  const {
    clientPortalEnableSuccessFactorsAtsIntegration,
    clientPortalEnableGreenhouseAtsIntegration,
    clientPortalEnableIcimsAtsIntegration,
    clientPortalEnableWorkableAtsIntegration,
  } = useFlags();

  return (
    <Routes>
      <Route path="/lever" element={<LeverIntegrationEditPage />} />
      <Route
        path="/workable"
        element={
          clientPortalEnableWorkableAtsIntegration ? (
            <WorkableIntegrationEditPage />
          ) : (
            <Navigate to="/settings/ats-integrations" replace />
          )
        }
      />
      <Route path="/workday" element={<WorkdayIntegrationEditPage />} />
      <Route path="/pageup" element={<PageUpIntegrationEditPage />} />
      <Route
        path="/successfactors"
        element={
          clientPortalEnableSuccessFactorsAtsIntegration ? (
            <SuccessFactorsIntegrationEditPage />
          ) : (
            <Navigate to="/settings/ats-integrations" replace />
          )
        }
      />
      <Route
        path="/greenhouse"
        element={
          clientPortalEnableGreenhouseAtsIntegration ? (
            <GreenhouseIntegrationEditPage />
          ) : (
            <Navigate to="/settings/ats-integrations" replace />
          )
        }
      />
      <Route
        path="/icims"
        element={
          clientPortalEnableIcimsAtsIntegration ? (
            <IcimsIntegrationEditPage />
          ) : (
            <Navigate to="/settings/ats-integrations" replace />
          )
        }
      />
      <Route path="/unified/*" element={<UnifiedIntegrationEditPage />} />
    </Routes>
  );
}
